import React, { useEffect, useState } from "react";
import "../styles/PWATimerDate.css";

const game1 = [
  { d: "MONDAY SPECIAL", day: "Monday", closingTime: "19:55" },
  { d: "LUCKY TUESDAY", day: "Tuesday", closingTime: "19:55" },
  { d: "MIDWEEK", day: "Wednesday", closingTime: "19:55" },
  { d: "FORTUNE THURSDAY", day: "Thursday", closingTime: "19:55" },
  { d: "FRIDAY BONANZA", day: "Friday", closingTime: "19:55" },
  { d: "NATIONAL WEEKLY", day: "Saturday", closingTime: "19:55" },
  { d: "SUNDAY ASEDA", day: "Sunday", closingTime: "17:55" },
];

const game2 = [
 { d: "NLA VAG MONDAY", day: "Monday", closingTime: "09:55" },
  { d: "NLA NOON RUSH MONDAY", day: "Monday", closingTime: "13:25" },
     { d: "HUNTEX MONDAY", day: "Monday", closingTime: "21:50" },
  { d: "NLA VAG TUESDAY", day: "Tuesday", closingTime: "09:55" },
  { d: "NLA NOON RUSH TUESDAY", day: "Tuesday", closingTime: "13:25" },
     { d: "HUNTEX AKOMA TUESDAY", day: "Tuesday", closingTime: "21:50" },
  { d: "NLA VAG WEDNESDAY", day: "Wednesday", closingTime: "09:55" },
  { d: "NLA NOON RUSH WEDNESDAY", day: "Wednesday", closingTime: "13:25" },
     { d: "HUNTEX WEDNESDAY", day: "Wednesday", closingTime: "21:50" },
  { d: "NLA VAG THURSDAY", day: "Thursday", closingTime: "09:55" },
  { d: "NLA NOON RUSH THURSDAY", day: "Thursday", closingTime: "13:25" },
    { d: "HUNTEX THURSDAY", day: "Thursday", closingTime: "21:50" },
  { d: "NLA VAG FRIDAY", day: "Friday", closingTime: "09:55" },
  { d: "NLA NOON RUSH FRIDAY", day: "Friday", closingTime: "13:25" },
   { d: "HUNTEX FRIDAY", day: "Friday", closingTime: "21:50" },
  { d: "NLA VAG SATURDAY", day: "Saturday", closingTime: "09:55" },
  { d: "NLA NOON RUSH SATURDAY", day: "Saturday", closingTime: "13:25" },
     { d: "HUNTEX SATURDAY", day: "Saturday", closingTime: "21:50" },
     { d: "HUNTEX SUNDAY", day: "Sunday", closingTime: "21:50" },
];

function getTimeRemaining(game) {
  const now = new Date();

  if (!Array.isArray(game)) {
    return [];
  }

  const validGames = game.filter((gameItem) => {
    if (!gameItem || typeof gameItem !== "object") return false;
    if (typeof gameItem.day !== "string" || typeof gameItem.closingTime !== "string") return false;
    return /^\d{1,2}:\d{2}$/.test(gameItem.closingTime);
  });

  const remainingTimes = validGames.map((gameItem) => {
    const gameDayIndex = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ].indexOf(gameItem.day);
    const currentDayIndex = now.getDay();

    let nextGameDayIndex = (gameDayIndex - currentDayIndex + 7) % 7;

    const nextGameDate = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate() + nextGameDayIndex
    );

    const closingTimeParts = gameItem.closingTime.split(":");
    const closingTime = new Date(
      nextGameDate.getFullYear(),
      nextGameDate.getMonth(),
      nextGameDate.getDate(),
      parseInt(closingTimeParts[0]),
      parseInt(closingTimeParts[1])
    );

    if (closingTime < now) {
      closingTime.setDate(closingTime.getDate() + 7);
      nextGameDate.setDate(nextGameDate.getDate() + 7);
    }

    const timeDifference = closingTime - now;
    const days = Math.floor(timeDifference / (24 * 60 * 60 * 1000));
    const hours = Math.floor(
      (timeDifference % (24 * 60 * 60 * 1000)) / (60 * 60 * 1000)
    );
    const minutes = Math.floor(
      (timeDifference % (60 * 60 * 1000)) / (60 * 1000)
    );
    const seconds = Math.floor((timeDifference % (60 * 1000)) / 1000);

    return {
      d: gameItem.d,
      day: gameItem.day,
      closingTime: closingTime.toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "numeric",
        second: "numeric",
        hour12: true,
      }),
      nextGameDate: nextGameDate.toLocaleDateString("en-US"),
      remainingTime: {
        days,
        hours,
        minutes,
        seconds,
      },
      nextGameStartTime: closingTime.toISOString(),
    };
  });

  const sortedGames = remainingTimes.sort((a, b) => {
    const timeA = new Date(a.nextGameStartTime).getTime();
    const timeB = new Date(b.nextGameStartTime).getTime();
    return timeA - timeB;
  });

  return sortedGames;
}

const PWATimerDate = () => {
  const [selectedGame, setSelectedGame] = useState(null);

  useEffect(() => {
    const fetchGameTimes = () => {
      const game1Times = getTimeRemaining(game1);
      const game2Times = getTimeRemaining(game2);
      const allGames = [...game1Times, ...game2Times].sort((a, b) => {
        const timeA = new Date(a.nextGameStartTime).getTime();
        const timeB = new Date(b.nextGameStartTime).getTime();
        return timeA - timeB;
      });
      setSelectedGame(allGames[0]);
    };

    fetchGameTimes();
    const interval = setInterval(fetchGameTimes, 1000);
    return () => clearInterval(interval);
  }, []);

  if (!selectedGame) return null;

  return (
    <div className="pwa-timer-card">
      <div className="pwa-timer-content">
        <div className="pwa-timer-header">
          <h3 className="pwa-next-game-label">LIVE GAME</h3>
          <p className="pwa-game-name">{selectedGame.d}</p>
        </div>

        <div className="pwa-time-boxes">
          <div className="pwa-time-box">
            <div className="pwa-time-value">
              {selectedGame.remainingTime.days}
            </div>
            <div className="pwa-time-label">Days</div>
          </div>
          <div className="pwa-time-box">
            <div className="pwa-time-value">
              {selectedGame.remainingTime.hours}
            </div>
            <div className="pwa-time-label">Hours</div>
          </div>
          <div className="pwa-time-box">
            <div className="pwa-time-value">
              {selectedGame.remainingTime.minutes}
            </div>
            <div className="pwa-time-label">Minutes</div>
          </div>
          <div className="pwa-time-box">
            <div className="pwa-time-value">
              {selectedGame.remainingTime.seconds}
            </div>
            <div className="pwa-time-label">Seconds</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PWATimerDate;
